import React from 'react'
import { Container, Typography, Paper } from '@mui/material'
import { usePage } from '@inertiajs/react'
import FlashMessages from '@/components/shared/FlashMessages'
import { AuthContainer } from '@/components/styled'
import { SPACING } from '@/theme'
import type { Flash } from '@/types'

interface AuthLayoutProps {
  children: React.ReactNode
  title?: string
}

export default function AuthLayout({ children, title = 'Sign in to your account' }: AuthLayoutProps) {
  const { flash } = usePage<{ flash: Flash }>().props

  return (
    <AuthContainer>
      <Container maxWidth="sm">
        <Typography
          variant="h4"
          component="h1"
          fontWeight={700}
          align="center"
          sx={{ letterSpacing: '-0.03em', mb: 4 }}
        >
          S3 Proxy
        </Typography>

        <FlashMessages flash={flash} />

        <Paper
          elevation={0}
          sx={{
            p: SPACING.form,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
          }}
        >
          <Typography variant="h2" component="h2" sx={{ mb: 3 }}>
            {title}
          </Typography>
          {children}
        </Paper>
      </Container>
    </AuthContainer>
  )
}
